import React, { Component } from "react";

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        Copyright 2024 Honda Car India - All Rights Reserved.
      </div>
    );
  }
}
